import { render, staticRenderFns } from "./bagsh_hvnii_nuuts.vue?vue&type=template&id=13d77cab&"
import script from "./bagsh_hvnii_nuuts.vue?vue&type=script&lang=js&"
export * from "./bagsh_hvnii_nuuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports